module.exports = __webpack_public_path__ + "img/func-keypal-0.c31690a6.png";